// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/lista
 *
 * List of sanitized subaccounts. Each row is the output of
 * subaccounts_model->sanitizeForFrontend(); shape is owned downstream
 * and varies by provider configuration.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_ListaResponseDados = unknown[];

export type SubaccountsFranchises_ListaResponse = ApiResponse<SubaccountsFranchises_ListaResponseDados>;

registerResponseContract('SubaccountsFranchises_ListaResponse', {})
